/* eslint-disable @scandipwa/scandipwa-guidelines/jsx-no-props-destruction */
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    mapDispatchToProps as sourceMapDispatchToProps,
    mapStateToProps as sourceMapStateToProps,
    SubscriptionContainer
} from 'Component/Subscription/Subscription.container';
import { updateCustomerDetails } from 'Store/MyAccount/MyAccount.action';
import { CustomerType } from 'Type/Account.type';

import { SubscriptionBlockFormComponent } from './SubscriptionBlockForm.component';

/** @namespace Scandipwa/Component/SubscriptionBlockForm/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    ...sourceMapDispatchToProps(dispatch),
    updateCustomer: (customer) => (dispatch(updateCustomerDetails(customer)))
});

/** @namespace Scandipwa/Component/SubscriptionBlockForm/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    ...sourceMapStateToProps(state),
    subscriptionBlockHeading: state.ConfigReducer.subscriptionBlockHeading,
    subscriptionBlockCta: state.ConfigReducer.subscriptionBlockCta,
    subscriptionBlockAdditional: state.ConfigReducer.subscriptionBlockAdditional,
    subscriptionBlockDisclaimer: state.ConfigReducer.subscriptionBlockDisclaimer,
    subscriptionBlockImage: state.ConfigReducer.subscriptionBlockImage,
    subscriptionBlockPromo: state.ConfigReducer.subscriptionBlockPromo,
    secure_base_media_url: state.ConfigReducer.secure_base_media_url,
    customer: state.MyAccountReducer.customer,
    isSignedIn: state.MyAccountReducer.isSignedIn
});

/** @namespace Scandipwa/Component/SubscriptionBlockForm/Container */
export class SubscriptionBlockFormContainer extends SubscriptionContainer {
    static propTypes = {
        subscriptionBlockHeading: PropTypes.string.isRequired,
        subscriptionBlockCta: PropTypes.string.isRequired,
        subscriptionBlockAdditional: PropTypes.string.isRequired,
        subscriptionBlockDisclaimer: PropTypes.string.isRequired,
        subscriptionBlockImage: PropTypes.string.isRequired,
        subscriptionBlockPromo: PropTypes.string.isRequired,
        secure_base_media_url: PropTypes.string.isRequired,
        customer: CustomerType.isRequired,
        isSignedIn: PropTypes.bool.isRequired,
        updateCustomer: PropTypes.func.isRequired,
        isFooter: PropTypes.bool
    };

    static defaultProps = {
        isFooter: false
    };

    render() {
        return (
            <SubscriptionBlockFormComponent
              { ...this.containerProps() }
              { ...this.props }
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionBlockFormContainer);
